import {v3} from "oc-threejs/short3";

export default class InterieurDragBox extends THREE.Mesh {

    sizeAdd = v3(1, 1, 5.1);

    constructor() {
        super();
        this.material = new THREE.MeshBasicMaterial({color: 0x93b4ed, opacity: 0.2, transparent: true});
        this.geometry = new THREE.BoxGeometry(1, 1, 1);
        this.material.visible = false;
        this.visible = false;
    }

    show(on) {
        this.visible = on;
        this.material.visible = on;
    }

    setSize(size) {
        this.scale.copy(size).add(this.sizeAdd);
    }

}
